<template>
  <div class="empty_box" :style="{height: scrollerHeight}">
    <div class="empty_inner">
      <img src="@/assets/error/好居新房安装成功.svg" alt="" />
      <p class="back">
        好居新房安装成功！
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      scrollerHeight:0,
    }
  },
  created(){
    this.getHeight();
  },
  methods: {
    getHeight(){
      var h=window.innerHeight
      || document.documentElement.clientHeight
      || document.body.clientHeight
      console.log(h)
      this.scrollerHeight = h - 128 + 'px'
    },
    goIndex() {
      this.$router.replace({
        path: '/'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.empty_box {
  width: 100%;
  position: relative;
  .empty_inner {
    position:absolute;
    top:50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    text-align: center;
    .back {
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 36px;
      color: #909399;
      .backbtn {
        color: #1c88ff;
        cursor: pointer;
        margin: 0 8px;
      }
    }
  }
}
</style>